export class ExtraMetaData {
    public __classname__: string = 'ExtraMetaData';

    public Property : string | null = null;
	public Values: string[] | null = null;

    constructor(params : ExtraMetaDataNamedParameters) {
        this.Property = params.Property ?? null;
        this.Values = params.Values ?? null;
    }
}

export interface ExtraMetaDataNamedParameters {
    Property?: string,
    Values?: string[]
}